import React from 'react';

const TabNavigation = ({ activeTab, setActiveTab, tabs }) => (
  <nav className="flex space-x-8" aria-label="Tabs">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        onClick={() => setActiveTab(tab.id)}
        className={`py-4 px-1 inline-flex items-center border-b-2 font-medium text-sm ${
          activeTab === tab.id
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        }`}
      >
        {tab.label}
      </button>
    ))}
  </nav>
);

export default TabNavigation;